<template>
  <div>
    <table width="100%">
      <tr>
        <td width="10%">&nbsp;</td>
        <td width="40%" style="padding-right: 100px; vertical-align: top">
          <p style="margin-bottom: 121px"><strong>Signed on behalf of the tour operator:</strong></p>
          <hr style="color: #000000" />
          <p>AUTHORIZED SIGNATURE </p>
          <p>{{bindContactPerson}}</p>
          <p>{{bindContactPosition}}</p>
          <table width="100%">
            <tr>
              <td style="vertical-align: bottom; height: 30px">DATE:</td>
              <td width="90%" style="vertical-align: bottom; height: 30px; border-bottom: 1px solid"></td>
            </tr>
          </table>
        </td>
        <td width="40%" style="padding-left: 100px; vertical-align: top">
          <p><strong>Signed on behalf of the Hotel:</strong></p>
          <p v-if="bindSignature === false" style="margin-bottom: 121px"></p>
          <p v-if="bindSignature !== false" style="text-align: center">
            <img id="sale-person-signature" height="80px" alt="Signature" :src="bindSignature">
          </p>
          <hr style="color: #000000" />
          <p>AUTHORIZED SIGNATURE</p>
          <p>{{bindSalePerson}}</p>
          <p>{{bindSalePersonPosition}}</p>
          <table width="100%">
            <tr>
              <td>DATE:</td>
              <td width="90%" style="height: 30px; border-bottom: 1px solid">
                {{bindContractDate}}
              </td>
            </tr>
          </table>
        </td>
        <td width="10%">&nbsp;</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { get } from 'lodash'
import { dateFormat } from '@/helpers/datetime'

export default {
  name: 'Singed',
  props: {
    contractDetail: {
      id: '',
      hotel: {},
      refCode: '',
      startDate: '',
      endDate: '',
      salePerson: {},
      contactPerson: {},
      internalNote: '',
      agentId: {},
      status: 1,
      rateCodeList: [],
      promotionList: [],
      supplementList: [],
      transferList: [],
      termOfPayment: {},
      termAndCondition: {}
    }
  },
  computed: {
    bindContactPerson: function () {
      const title = get(this.contractDetail, 'agent.contactPerson.title', '')
      const firstName = get(this.contractDetail, 'agent.contactPerson.firstName', '')
      const lastName = get(this.contractDetail, 'agent.contactPerson.lastName', '')

      return `${title} ${firstName} ${lastName}`
    },
    bindSalePerson: function () {
      const title = get(this.contractDetail, 'salePerson.title', '')
      const firstName = get(this.contractDetail, 'salePerson.firstName', '')
      const lastName = get(this.contractDetail, 'salePerson.lastName', '')

      return `${title} ${firstName} ${lastName}`
    },
    bindContractDate: function () {
      const updatedDateStr = get(this.contractDetail, 'updatedAt', '')

      if (updatedDateStr !== '') {
        const updatedDate = new Date(updatedDateStr)
        return dateFormat.short(updatedDate, 'short', 'en')
      }

      return ''
    },
    bindContactPosition: function () {
      const position = get(this.contractDetail, 'agent.contactPerson.position', '')
      return position
    },
    bindSalePersonPosition: function () {
      const position = get(this.contractDetail, 'salePerson.position', '')
      return position
    },
    bindSignature: function () {
      const isAddSignature = Boolean(get(this.contractDetail, 'salePerson.isAddSignature', 0))
      const signatureUrl = get(this.contractDetail, 'salePerson.signatureUrl', '')

      if (isAddSignature === true && signatureUrl !== '') {
        return signatureUrl
      }

      return false
    }
  }
}
</script>
